import { New } from '@/Domain/News'

export class NewDTO {
  private _title: string
  private _newDate: string
  private _content: string

  static fromNew (newItem: New): NewDTO {
    return new NewDTO(
      newItem.title(),
      newItem.newDate(),
      newItem.content()
    )
  }

  constructor (
    title: string,
    newDate: string,
    content: string
  ) {
    this._title = title
    this._newDate = newDate
    this._content = content
  }

  get title (): string {
    return this._title
  }

  get newDate (): string {
    return this._newDate
  }

  get content (): string {
    return this._content
  }
}
